<template>
  <div class="main-page">
    <div class="main-wallet">
      <div v-for="account in accounts" :key="account.id">
        <div class="main-wallet__top">
          <div class="main-wallet__main-info">
            <div class="main-wallet__icon">
              <img :src="helper.currencyIcon(account.currency)">
            </div>
            <div class="main-wallet__info">
              <div class="main-wallet__sum">
                <span>{{ numberFormatter.formatNumber(account.sumWithoutInsurance) }}</span> {{account.currency}}
              </div>
              <div class="main-wallet__wallet">
                    <span class="main-wallet__wallet-address for-copy">
                        {{ account._wallet ? truncateAddress(account._wallet.address) : '' }}
                    </span>
                <span>(USDT TRC20)</span>
                <CopyButton :value="account._wallet?.address"></CopyButton>
              </div>
            </div>
          </div>
          <div class="main-wallet__controls">
            <a v-if="isTrader" href="#" @click.prevent="showWithdrawal(account)" class="btn main-wallet__btn"><span class="text-capitalize-first">{{ $t('button.withdraw')}}</span></a>
            <a href="#" @click.prevent="showHistory(account)" class="btn main-wallet__btn"><span class="text-capitalize-first">{{ $t('button.history')}}</span></a>
          </div>
        </div>
        <div class="main-wallet__numbers">
          <div class="main-wallet__number">
            <div class="main-wallet__number-icon">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4915 3.3555C14.6344 3.23694 14.8143 3.17206 15 3.17206C15.1857 3.17206 15.3656 3.23694 15.5085 3.3555C18.5049 5.84798 22.2323 7.29563 26.1255 7.479C26.3009 7.4844 26.4689 7.55115 26.6002 7.66764C26.7315 7.78412 26.8178 7.94296 26.844 8.1165C26.9475 8.8965 27 9.6915 27 10.5015C27 18.2445 22.11 24.846 15.249 27.3855C15.0883 27.4447 14.9117 27.4447 14.751 27.3855C7.89 24.846 3 18.2445 3 10.5C3 9.693 3.0525 8.8965 3.156 8.1165C3.18229 7.94271 3.26878 7.78368 3.40038 7.66717C3.53197 7.55065 3.70031 7.48405 3.876 7.479C7.76891 7.29488 11.4957 5.84822 14.4915 3.3555ZM20.7855 12.2865C20.9609 12.045 21.0333 11.7437 20.9866 11.4489C20.9399 11.1541 20.778 10.8899 20.5365 10.7145C20.295 10.5391 19.9937 10.4667 19.6989 10.5134C19.4041 10.5601 19.1399 10.722 18.9645 10.9635L13.74 18.1485L10.92 15.3285C10.8162 15.2211 10.692 15.1355 10.5547 15.0766C10.4174 15.0177 10.2698 14.9867 10.1204 14.9855C9.97104 14.9842 9.82291 15.0128 9.68468 15.0694C9.54645 15.126 9.42088 15.2096 9.3153 15.3153C9.20972 15.421 9.12625 15.5466 9.06975 15.6849C9.01325 15.8232 8.98485 15.9714 8.98622 16.1207C8.98759 16.2701 9.01869 16.4177 9.07772 16.5549C9.13674 16.6922 9.2225 16.8163 9.33 16.92L13.08 20.67C13.1949 20.785 13.3334 20.8737 13.486 20.9301C13.6385 20.9864 13.8014 21.009 13.9635 20.9963C14.1256 20.9836 14.283 20.9359 14.4249 20.8566C14.5668 20.7772 14.6899 20.668 14.7855 20.5365L20.7855 12.2865Z" fill="#00A3FB" />
              </svg>
            </div>
            <div class="main-wallet__number-info">
              <div class="main-wallet__number-title">
                {{$t('labels.insurance_limit')}}:
              </div>
              <div class="main-wallet__number-summ">
                {{ numberFormatter.formatNumber(account.insuranceSum.amount, 2) }} / {{ numberFormatter.formatNumber(account.insuranceLimitSum.amount, 2) }} {{ account.insuranceLimitSum.currency }}
              </div>
            </div>
          </div>
          <div class="main-wallet__number">
            <div class="main-wallet__number-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 139.186 16.8 21.52" width="16.8px" height="21.52px">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M 4.6 148.706 L 2.8 148.706 L 2.4 148.706 C 1.763 148.706 1.153 148.959 0.703 149.409 C 0.253 149.859 0 150.47 0 151.106 L 0 158.306 C 0 158.943 0.253 159.553 0.703 160.003 C 1.153 160.453 1.763 160.706 2.4 160.706 L 14.4 160.706 C 15.036 160.706 15.647 160.453 16.097 160.003 C 16.547 159.553 16.8 158.943 16.8 158.306 L 16.8 151.106 C 16.8 150.47 16.547 149.859 16.097 149.409 C 15.647 148.959 15.036 148.706 14.4 148.706 L 4.6 148.706 Z" fill="#00A3FB" style="stroke-width: 1;" transform="matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M 8.402 139.186 C 6.97 139.186 5.596 139.755 4.583 140.768 C 3.571 141.78 3.002 143.154 3.002 144.586 L 3.002 148.786 L 4.802 148.786 L 4.802 144.586 C 4.802 143.631 5.181 142.716 5.856 142.04 C 6.531 141.365 7.447 140.986 8.402 140.986 C 9.357 140.986 10.272 141.365 10.947 142.04 C 11.623 142.716 12.002 143.631 12.002 144.586 L 11.992 148.714 C 12.005 148.739 13.844 148.796 13.822 148.784 L 13.802 144.586 C 13.802 143.877 13.662 143.175 13.391 142.52 C 13.119 141.864 12.722 141.269 12.22 140.768 C 11.719 140.266 11.124 139.868 10.468 139.597 C 9.813 139.326 9.111 139.186 8.402 139.186 Z" fill="#00A3FB" style="stroke-width: 1;" transform="matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)"/>
              </svg>
            </div>
            <div class="main-wallet__number-info">
              <div class="main-wallet__number-title text-capitalize-first">
                {{ $t('dashboard.on_hold') }}:
              </div>
              <div class="main-wallet__number-summ">
                {{ numberFormatter.formatNumber(account.frozenSum) }} {{ account.sum.currency }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-wallet__percents">
        <div class="main-wallet__percents-title">{{ $t("dashboard.trade_reward")}}</div>
        <div v-for="(rewardSettings, direction) in {'in':payInRewardFee, 'out': payOutRewardFee}">
          <div class="main-wallet__percents-title">
            <span class="text-capitalize-first">{{ $t(`direction.${direction}`) }}:</span>
          </div>
          <div class="main-wallet__percents-list">
            <div class="main-wallet__percents-item" v-for="settings in rewardSettings" :key="settings.name">
              <div>
                <b>{{ settings.name }}:</b> <span>{{ numberFormatter.formatNumber(parseFloat(settings.reward), 1) }}%</span> <span :class="parseFloat(settings.additional) > 0 ? 'text-success' : ''" v-if="settings.additional">{{ parseFloat(settings.additional) > 0 ? '+' : '' }}{{numberFormatter.formatNumber(parseFloat(settings.additional), 1) }}%</span>
              </div>
              <div v-if="settings.traderFeeByDealAmount && settings.traderFeeByDealAmount.length > 0" class="mt-1">
                <small class="text-muted">{{ $t('labels.fee_ranges') }}</small>
                  <div class="small">
                    <span v-for="(range, index) in settings.traderFeeByDealAmount" :key="index" class="me-2">
                      <span v-if="range.minSum && range.maxSum">
                        {{ numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2) }} - {{ numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2) }} {{ range.currency }}: {{ numberFormatter.formatNumber(parseFloat(range.fee), 1) }}%
                      </span>
                      <span v-else-if="range.minSum">
                        ≥{{ numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2) }} {{ range.currency }}: {{ numberFormatter.formatNumber(parseFloat(range.fee), 1) }}%
                      </span>
                      <span v-else-if="range.maxSum">
                        ≤{{ numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2) }} {{ range.currency }}: {{ numberFormatter.formatNumber(parseFloat(range.fee), 1) }}%
                      </span>
                    </span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-wallet__percents" v-if="currencyRatesByGroups.length > 0">
        <div class="main-wallet__percents-title">{{ $t("labels.currency_rates")}}</div>
        <div v-for="(currencyRates, direction) in {'in':currencyRatesByGroups.filter(item =>item.direction === 'in'), 'out': currencyRatesByGroups.filter(item =>item.direction === 'out')}">
          <div class="main-wallet__percents-title">
            <span class="text-capitalize-first">{{ $t(`direction.${direction}`) }}:</span>
          </div>
          <div class="main-wallet__percents-list">
            <div class="main-wallet__percents-item" v-for="settings in currencyRates" :key="settings.name">
              <div class="d-flex gap-sm">
                <b>{{ settings.name }}:</b> <span v-for="(item, index) in settings.currencyRates" :key="index">{{ numberFormatter.formatMoney(item.rate) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-for="todayStat in [todayPayInStats, todayPayOutStats]">
      <div class="main-deals" v-if="todayStat">
        <div class="main-deals__item">
          <div class="main-deals__title">
            {{ $t(`labels.today_stat.deals.${todayStat.type}`) }}
          </div>
          <template v-if="todayStat">
            <template v-for="item in todayStat.items">
              <div class="main-deals__sum">
                <span>{{ numberFormatter.formatMoney(item.completedTakerSum)}}&nbsp</span>
                <sup>
                  <span>{{numberFormatter.formatMoney(item.completedMakerSum, 2)}}</span>
                </sup>
              </div>
              <div class="main-deals__summery">
                <span class="main-deals__deals-count">
                    {{ $t('labels.today_completed') }}: <span>{{item.completedCount}}</span>
                </span>
                <span class="main-deals__canceled-count">
                    &nbsp{{ $t('labels.today_canceled') }}: <span>{{item.canceledCount}}</span>
                </span>
              </div>
            </template>
          </template>
        </div>
        <div class="main-deals__item">
          <div class="main-deals__title">
            {{ $t(`labels.today_stat.rewards.${todayStat.type}`) }}
          </div>
          <template v-if="todayStat">
            <template v-for="item in todayStat.items">
              <div class="main-deals__sum">
                <span>{{ numberFormatter.formatMoney(item.rewardSum, 2)}}&nbsp</span>
              </div>
            </template>
          </template>
        </div>
      </div>
    </template>

    <div class="deals">
      <div class="active-disputes">
        <div class="active-disputes__title">
          <span class="text-capitalize-first">{{ $t('labels.active_disputes')}}</span>
        </div>
        <DealsSection :hide-header="true" ref="activeDisputesSection"></DealsSection>
      </div>
    </div>

    <div class="deals" v-if="onlineAmountsStats.options && onlineAmountsStats.options?.length > 0">
      <div class="main-item  deal">
        <table class="table align-middle text-left text-nowrap position-relative">
          <thead>
          <tr class="">
            <th style="width: 0">
              <span class="text-capitalize-first main-wallet__percents-title">{{$t('labels.sum')}}</span>
            </th>
            <th :style="{'width': (100 / onlineAmountsStats.options.length) + '%'}" v-for="option in onlineAmountsStats.options" :key="option" class="text-capitalize">
              <span v-if="option" class="main-wallet__percents-title">{{ helper.trans(`payment_options.${option}`)}}</span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(stat, index) in onlineAmountsStats.stat" :key="index">
            <td class="p-sm" style="text-align: right">
              <span style="white-space: nowrap">{{numberFormatter.formatNumber(stat.min)}} - {{numberFormatter.formatNumber(stat.max)}}</span>
            </td>
            <td v-for="option in onlineAmountsStats.options" :key="option" class="p-sm">

              <b-progress max="100" class="position-relative stat-progress-bar">
                <b-progress-bar :value="parseInt(stat.stats[option]?.percent)" :style="{background: getProgressBackground(stat.stats[option]?.percent)}" class=""></b-progress-bar>
                <small class="justify-content-center d-flex position-absolute w-100"></small>
              </b-progress>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>

  </div>
  <AccountOperationPopup ref="accountOperationPopup"/>
  <WithdrawalPopup ref="withdrawalPopup"/>
</template>
<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {$t, helper, truncateAddress} from "@/service/CommonHelper";
import {useStore} from "vuex";
import AccountDTO from "@/models/AccountDTO";
import {api} from "@/service/APIClient";
import {numberFormatter} from "@/service/NumberFormatter";
import WalletDTO from "@/models/WalletDTO";
import {Dictionary} from "@/types";
import TraderRewardSettingsDTO from "@/models/TraderRewardSettingsDTO";
import {Direction} from "@/models/enum/Direction";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {DealStatus} from "@/models/enum/DealStatus";
import {dateHelper} from "@/service/DateHelper";
import moment from "moment";
import MoneyDTO from "@/models/MoneyDTO";
import AccountOperationPopup from "@/apps/public/components/AccountOperationPopup.vue";
import WithdrawalPopup from "@/apps/public/components/WithdrawalPopup.vue";
import {defaultRequestDTO} from "@/models/request/DealRequestDTO";
import DealsSection from "@/apps/public/components/DealsSection.vue";


interface TodayStatItem {
  totalCount: number
  completedCount: number
  canceledCount: number
  completedTakerSum: MoneyDTO
  completedMakerSum: MoneyDTO
  rewardSum: MoneyDTO
}

interface TodayStat {
  type: Direction
  totalCount: number
  completedCount: number
  canceledCount: number
  makerSum: MoneyDTO
  rewardSum: MoneyDTO
  items: Dictionary<TodayStatItem>
}

export default defineComponent({
  name: 'TraderDashboard',
  methods: {$t},
  components: {
    DealsSection,
    WithdrawalPopup,
    CopyButton,
    AccountOperationPopup
  },
  setup: function () {
    const accountOperationPopup = ref<InstanceType<typeof AccountOperationPopup> | null>(null)
    const withdrawalPopup = ref<InstanceType<typeof WithdrawalPopup> | null>(null)
    const activeDisputesSection = ref<InstanceType<typeof DealsSection> | null>(null)
    const store = useStore()

    const state = reactive({
      rewardSettings: [] as TraderRewardSettingsDTO[],
      accounts: [] as AccountDTO[],
      todayPayInStats: null as TodayStat|null,
      todayPayOutStats: null as TodayStat|null,
      currencyRatesByGroups: [] as any[],
      onlineAmountsStats: [] as any,
    });

    const loadCurrencyRatesSettings = async () => {
      state.currencyRatesByGroups = await api.traderCurrencyRatesByGroupsSettings()
    }

    const loadTodayStatistic = async () => {
      const stats = await api.statisticSummary({
        fromDate: dateHelper.toUTC(moment().format('YYYY-MM-DD 00:00:00')),
        statuses: [DealStatus.COMPLETED, DealStatus.CANCELED]
      });

      let todayStats = {} as Dictionary<TodayStat>

      for (const item of stats) {
        if (!todayStats[item.type]) {
          todayStats[item.type] = {
            type: item.type,
            totalCount: 0,
            completedCount: 0,
            canceledCount: 0,
            makerSum: item.makerSum,
            rewardSum: item.traderRewardSum,
            items: {} as Dictionary<TodayStatItem>
          } as TodayStat;
        } else {
          if (item.status === DealStatus.COMPLETED) {
            if (item.makerSum) {
              todayStats[item.type].makerSum = helper.sum(todayStats[item.type].makerSum, item.makerSum)
            }

            if (item.traderRewardSum) {
              todayStats[item.type].rewardSum = helper.sum(todayStats[item.type].rewardSum, item.traderRewardSum)
            }
          }
        }

        if (item.status === DealStatus.COMPLETED) {
          todayStats[item.type].completedCount += item.count
        } else if (item.status === DealStatus.CANCELED) {
          todayStats[item.type].canceledCount += item.count
        }

        todayStats[item.type].totalCount += item.count

        if (item.takerSum) {
          if (!todayStats[item.type].items[item.takerSum.currency]) {
            todayStats[item.type].items[item.takerSum.currency] = {
              totalCount: 0,
              completedCount: 0,
              canceledCount: 0,
              completedTakerSum: {amount: '0', currency: item.takerSum.currency, subunit: item.takerSum.subunit} as MoneyDTO,
              completedMakerSum: {amount: '0', currency: 'USDT', subunit: 8} as MoneyDTO,
              rewardSum: {amount: '0', currency: 'USDT', subunit: 8} as MoneyDTO,
            } as TodayStatItem
          }
          todayStats[item.type].items[item.takerSum.currency].totalCount = todayStats[item.type].items[item.takerSum.currency].totalCount + item.count
          if (item.status === DealStatus.COMPLETED) {
            todayStats[item.type].items[item.takerSum.currency].completedCount += item.count
            todayStats[item.type].items[item.takerSum.currency].completedTakerSum = helper.sum(todayStats[item.type].items[item.takerSum.currency].completedTakerSum, item.takerSum)
            if (item.makerSum) {
              todayStats[item.type].items[item.takerSum.currency].completedMakerSum = helper.sum(todayStats[item.type].items[item.takerSum.currency].completedMakerSum, item.makerSum)
            }

            if (item.traderRewardSum) {
              todayStats[item.type].items[item.takerSum.currency].rewardSum = helper.sum(todayStats[item.type].items[item.takerSum.currency].rewardSum, item.traderRewardSum)
            }

          } else if (item.status === DealStatus.CANCELED) {
            todayStats[item.type].items[item.takerSum.currency].canceledCount += item.count
          }
        }
      }

      state.todayPayInStats = todayStats[Direction.PAY_IN]
      state.todayPayOutStats = todayStats[Direction.PAY_OUT]
    }

    const loadAccounts = async () => {
      state.accounts = await api.accountsAll();
      let currencies = []
      for (const account of state.accounts) {
        currencies.push(account.currency)
      }
      store.dispatch('setAccountCurrencies', currencies);

      loadWallets();
    }

    const loadRewardSettings = async () => {
      state.rewardSettings = await api.traderRewardSettings();
    }

    const loadWallets = async () => {
      let promises = []
      for (const account of state.accounts) {
        promises.push(api.accountWallet(account.id))
      }
      const wallets = {} as Dictionary<WalletDTO>
      for (const resp of await Promise.all(promises)) {
        if (resp.accountId) {
          wallets[resp.accountId] = resp
        }
      }

      for (const account of state.accounts) {
        account._wallet = wallets[account.id] ?? null
      }
    }

    onMounted(async () => {
      loadAccounts();
      loadRewardSettings();
      loadCurrencyRatesSettings();
      loadTodayStatistic();
      api.statisticOnlineAmounts().then(resp => state.onlineAmountsStats = resp);
      activeDisputesSection.value?.update({
        ...defaultRequestDTO,
        statuses: [DealStatus.DISPUTE]
      }, 1, [])
    });

    const showWithdrawal = (account: AccountDTO) => {
      withdrawalPopup.value?.show(account)
    }

    const showHistory = (account: AccountDTO) => {
      accountOperationPopup.value?.show(account)
    }

    const payInRewardFee = computed<TraderRewardSettingsDTO[]>(() => {
      return state.rewardSettings.filter((item) => item.direction === Direction.PAY_IN)
    })

    const payOutRewardFee = computed<TraderRewardSettingsDTO[]>(() => {
      return state.rewardSettings.filter((item) => item.direction === Direction.PAY_OUT)
    })

    const getProgressBackground = (percent:number) => {
      if (percent <= 20) {
        return 'linear-gradient(to right, green, limegreen)';
      } else if (percent <= 50) {
        return 'linear-gradient(to right, orange, orangered)';
      } else {
        return 'linear-gradient(to right, red, darkred)';
      }
    }

    return {
      ...toRefs(state),
      getProgressBackground,
      truncateAddress,
      showHistory,
      showWithdrawal,
      withdrawalPopup,
      accountOperationPopup,
      activeDisputesSection,
      numberFormatter,
      payInRewardFee,
      payOutRewardFee,
      store,
      helper,
      isTrader: computed(() => store.getters.isTrader),
    }
  }
})
</script>
